/** @format */

export const POST_CONFIG = 'POST_CONFIG'
export const POST_CONFIG_SUCCESS = 'POST_CONFIG_SUCCESS'
export const POST_CONFIG_ERROR = 'POST_CONFIG_ERROR'

export const GET_CONFIG_COMPANY = 'GET_CONFIG_COMPANY'
export const GET_CONFIG_COMPANY_SUCCESS = 'GET_CONFIG_COMPANY_SUCCESS'
export const GET_CONFIG_COMPANY_ERROR = 'GET_CONFIG_COMPANY_ERROR'
